export const COMPARE_LIMIT_ERROR = "Нельзя добавить больше 10 объявлений в сравнение.";